import React from 'react';
import { Routes, Route } from 'react-router-dom';
import './ButtonBar.css';

const Buttons = (props: any) =>
    <table>
        <tbody>
            <tr>
                {props.buttons.map((button: any, i: number) => <td key={`${props.label}:${i}`}>{button}</td>)}
                <td key={`${props.label}:empty`}></td>
            </tr>
        </tbody>
    </table>



const ButtonBar = (props: any) =>
    <div className="ButtonBar">
        <Routes>
            {props.routes.map((route: {
                path: any;
                main: any;
                buttons: any;
            }) => (
                <Route
                    key={`${route.path()}.Buttons`}
                    path={route.path()}
                    element={<Buttons buttons={route.buttons as any[]} label={route.path()} />}
                />

            ))}
        </Routes>

    </div>


export default ButtonBar